import React from 'react';
import ReactDOM from 'react-dom';
import Login from './auth/Login';
import AuthComponent from './auth/AuthComponent';
import Dashboard from './dashboard/Dashboard';
import Stats from './stats/Stats';
import Html from './dashboard/archive/Html';
import {configureHttp, http} from './common/services/http'
import App from './common/components/App'
import { Router, Route, Redirect, browserHistory } from 'react-router'
import * as authService from './common/services/authService';
import './index.css';

configureHttp(
    () => document.getElementById('indicator').className = "waitForAction",
    () => document.getElementById('indicator').className = "",
    (error) => authService.logoutOnErrorIfNecessary(error)
);

const login = http => (<Login http={http}/>);

const dashboard = http => (<Dashboard http={http}/>);

const html = http => (<Html http={http}/>);

const stats = http => (<Stats http={http}/>);

ReactDOM.render(
    <div id="indicator" className=""/>,
    document.getElementById('wait')
);

ReactDOM.render(
    <Router history={browserHistory}>
        <Route path="" component={App}>
            <Route path="/login" component={() => login(http)} />
            <Route path="/dashboard" component={() => <AuthComponent wrapped={dashboard(http)} />} />
            <Route path="/current-html" component={() => <AuthComponent wrapped={html(http)} />} />
            <Route path="/stats" component={() => <AuthComponent wrapped={stats(http)} />} />
            <Redirect from="*" to="/dashboard"  />
        </Route>
    </Router>, document.getElementById('content')
);



// WEBPACK FOOTER //
// ./src/index.js